<template>
  <Modal ref="modal" title="Dar desconto" @cancel="close">
    <form class="discount-container" @submit.prevent="handleSubmit">
      <Input type="currency" legend="Valor" :modelValue="amount" @update:modelValue="$event => amount = $event"
        :disabled="loading" />

      <Textarea legend="Motivo do desconto" @update:modelValue="$event => (this.justificativa = $event)"
        :modelValue="justificativa" :disabled="loading" />

      <Button class="center-button" type="submit" text="Confirmar" color="primary" :disabled="loading"></Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Input from 'core/Input'
import Textarea from 'core/Textarea'
import Button from 'core/Button'

export default {
  name: 'DiscountModal',
  components: {
    Modal,
    Input,
    Textarea,
    Button,
  },
  data() {
    return {
      faturaId: '',
      schema: '',
      amount: 0,
      justificativa: '',
      loading: false,
    }
  },
  methods: {
    open(id, schema) {
      this.faturaId = id
      this.schema = schema

      this.$refs.modal.open()
    },
    close() {
      this.faturaId = ''
      this.schema = ''
      this.amount = 0
      this.justificativa = ''

      this.$refs.modal.close()
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        this.loading = true

        const data = {
          faturaId: this.faturaId,
          faturaSchema: this.schema,
          discountValue: this.amount / 100,
          reason: this.justificativa,
        }

        await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/desconto`, data)
          .then(res => {
            this.$toasted.show(res.body.mensagem, {
              position: 'top-right',
            })

            this.$emit('submit:sucess')

            this.close()
          })
          .catch(err => {
            this.$toasted.show(err.body.mensagem, {
              position: 'top-right',
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    validateInputs() {
      if (!this.amount || !this.justificativa) {
        this.toast('Preencha todos os campos!')

        return false
      }

      if (this.justificativa.length < 5) {
        this.toast('A justificativa precisa ter no mínimo 5 caracteres!')

        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.discount-container {
  min-width: 30vw;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  .center-button {
    justify-content: center;
  }
}
</style>